import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { arrangeColumns } from '@user/components/xGrid'
import {
  selectSCWebhooksColumnOrder,
  useLoadListViewPreferencesOnce,
} from '@user/store/userPreferences'
import { useGridApiRef } from '@mui/x-data-grid-pro'
import { webhookListColumns } from '@user/components/Settings/SCWebhooks/hooks/tableColumn'
import { SalesCenterWebhook } from '@user/store/scWebHooks'
import { useTidalThemeActive } from '@user/features/TidalThemeToggle'

interface Props {
  handleEditClick: (webhook: SalesCenterWebhook) => void
  handleDeleteRequest: (webhookId: number) => void
  onChangeStatus: (webhook: SalesCenterWebhook) => void
}

export const useGetColumnData = (props: Props) => {
  const { handleEditClick, handleDeleteRequest, onChangeStatus } = props
  const userPrefsLoading = useLoadListViewPreferencesOnce()
  const apiRef = useGridApiRef()
  const tidalThemeActive = useTidalThemeActive()

  const columnOrder = useSelector(selectSCWebhooksColumnOrder)
  const [columns, columnVisibility] = useMemo(
    () =>
      arrangeColumns(
        columnOrder,
        webhookListColumns({
          handleEditClick,
          handleDeleteRequest,
          onChangeStatus,
          tidalThemeActive,
        }),
        [],
        [],
      ),
    [
      columnOrder,
      handleEditClick,
      handleDeleteRequest,
      onChangeStatus,
      tidalThemeActive,
    ],
  )

  const loading = userPrefsLoading

  return { loading, columns, columnVisibility, apiRef }
}
